import { publishNotification } from '@shared/core/notification-center';

export function useNotifications() {
  const success = (message: string, duration = 5000) => {
    publishNotification({ message, type: 'success', duration });
  };

  const error = (message: string, duration = 5000) => {
    publishNotification({ message, type: 'error', duration });
  };

  const warning = (message: string, duration = 5000) => {
    publishNotification({ message, type: 'warning', duration });
  };

  const info = (message: string, duration = 5000) => {
    publishNotification({ message, type: 'info', duration });
  };

  return {
    success,
    error,
    warning,
    info
  };
}
